import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "medical-footer"
};
const _hoisted_2 = {
  class: "footer-content"
};
const _hoisted_3 = {
  class: "footer-section about"
};
const _hoisted_4 = {
  class: "footer-logo"
};
const _hoisted_5 = {
  class: "footer-section links"
};
const _hoisted_6 = {
  class: "footer-section contact"
};
const _hoisted_7 = {
  class: "view-count-container"
};
const _hoisted_8 = {
  class: "view-count-number"
};
const _hoisted_9 = {
  class: "footer-bottom"
};
const _hoisted_10 = {
  class: "social-icons"
};
const _hoisted_11 = {
  href: "#",
  class: "social-icon"
};
const _hoisted_12 = {
  href: "#",
  class: "social-icon"
};
import { Location, Message, Phone, MessageBox, Share, Connection } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import { ref, onMounted, computed } from 'vue';
import { useViewCountStore } from '@/stores/viewCountStore';
export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {
    const viewCount = ref(0);
    const viewCountStore = useViewCountStore();
    const goBeian = () => {
      window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank');
    };
    const copyUrl = async () => {
      try {
        const currentUrl = window.location.href; // 获取当前页面完整URL
        await navigator.clipboard.writeText(currentUrl);
        ElMessage.success('链接已复制！'); // 使用提示组件反馈
      } catch (err) {
        // console.error('复制失败:', err);
        ElMessage.error('复制失败，请手动复制');
      }
    };
    // 格式化数字，让大数字显示更友好（如1,234,567）
    const formatNumber = num => {
      return new Intl.NumberFormat().format(num);
    };
    // 添加数字滚动效果的函数
    const animateCount = (el, start, end, duration) => {
      let startTime = null;
      const step = timestamp => {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        const current = Math.floor(progress * (end - start) + start);
        el.textContent = formatNumber(current);
        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          el.textContent = formatNumber(end);
        }
      };
      window.requestAnimationFrame(step);
    };
    //获取并显示网站浏览量
    const getViewCount = async () => {
      const count = await viewCountStore.fetchSiteViewCount();
      viewCount.value = count;
      // 添加延迟，确保DOM已经渲染
      setTimeout(() => {
        const countElement = document.querySelector('.view-count-number');
        if (countElement) {
          animateCount(countElement, 0, count, 1500);
        }
      }, 500);
    };
    // 在模板中显示格式化后的数字
    const formattedViewCount = computed(() => {
      return formatNumber(viewCount.value);
    });
    onMounted(() => {
      getViewCount();
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_Platform = _resolveComponent("Platform");
      return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "logo-area"
      }, [_createElementVNode("h3", null, "医学教育平台")], -1)), _cache[2] || (_cache[2] = _createElementVNode("p", null, "为医学教育者与学习者提供专业的教学资源共享平台", -1)), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_image, {
        src: "https://gyyyfsk.oss-cn-shenzhen.aliyuncs.com/assets/%E5%85%AC%E4%BC%97%E5%8F%B7%E4%BA%8C%E7%BB%B4%E7%A0%81",
        style: {
          "width": "100px",
          "height": "100px"
        }
      }), _cache[0] || (_cache[0] = _createElementVNode("p", null, "友情链接", -1))])]), _createElementVNode("div", _hoisted_5, [_cache[7] || (_cache[7] = _createElementVNode("h4", null, "快速链接", -1)), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/"
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("首页")])),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/courses"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("课件中心")])),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/courseware"
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("微课")])),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/images"
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("医学图库")])),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_6, [_cache[11] || (_cache[11] = _createElementVNode("h4", null, "联系我们", -1)), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Location))]),
        _: 1
      }), _cache[8] || (_cache[8] = _createTextVNode(" 技术支持：广州医教网科技有限公司 "))]), _createElementVNode("li", null, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Message))]),
        _: 1
      }), _cache[9] || (_cache[9] = _createTextVNode(" 394886866@qq.com "))]), _createElementVNode("li", null, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Phone))]),
        _: 1
      }), _cache[10] || (_cache[10] = _createTextVNode(" 18816800808 "))])])])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Platform, {
          color: "#fff"
        })]),
        _: 1
      }), _cache[12] || (_cache[12] = _createElementVNode("span", {
        class: "view-count-label"
      }, "网站浏览量：", -1)), _createElementVNode("span", _hoisted_8, _toDisplayString(formattedViewCount.value), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("a", _hoisted_11, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(MessageBox))]),
        _: 1
      })]), _createElementVNode("a", {
        onClick: _withModifiers(copyUrl, ["prevent"]),
        href: "#",
        class: "social-icon"
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Share))]),
        _: 1
      })]), _createElementVNode("a", _hoisted_12, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Connection))]),
        _: 1
      })])]), _createElementVNode("p", {
        class: "copyright"
      }, [_createElementVNode("span", {
        class: "BeiAn",
        onClick: goBeian
      }, "粤ICP备2025418069号-2"), _cache[13] || (_cache[13] = _createTextVNode(" © 2025 广州医教网科技有限公司 All Rights Reserved. "))])])]);
    };
  }
});